import React from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';

import commaize from 'js/utils/commaize';
import { trackClick } from 'js/utils/trackClick';
import { TextButton } from 'js/design_system/TextButton';

const Container = styled.div`
  width: 100%;
  padding-top: 20px;
  text-align: center;
`;

const Title = styled.div`
  color: #000;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
`;

const Description = styled.div`
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding-top: 6px;
`;

type Props = {
  mentionsCount: number;
  onClickUpgrade: () => void;
};

const TasteOfMentionsHeader = ({ mentionsCount, onClickUpgrade }: Props) => {
  const onClick = () => {
    trackClick({
      source: 'TasteOfMentionsHeader',
      extra: {},
    });
    onClickUpgrade();
  };

  return (
    <Container>
      <Title>Welcome to Your Premium Trial</Title>
      <Description>
        Your trial unlocks 2 new Mentions every 2 days.
        <br />
        Want immediate access to all {commaize(mentionsCount)}{' '}
        {pluralize('Mention', mentionsCount)}?{' '}
        <TextButton inline {...{ onClick }}>
          Upgrade to Premium now
        </TextButton>
      </Description>
    </Container>
  );
};

export default TasteOfMentionsHeader;
